import { decode, isBlurhashValid } from 'blurhash'

// RGBA pixels for a blurhash, or null when the hash is unusable.
export const decodeBlurhash = (hash, width, height) => {
  if (typeof hash !== 'string' || !isBlurhashValid(hash).result) return null
  try {
    return decode(hash, width, height)
  } catch {
    return null
  }
}
